module.exports = __webpack_public_path__ + "img/half-active-star.66b7c30.svg";